var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTryBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1277,
    height: 500,
    viewBox: "0 0 1277 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_337)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1276.8,
    height: 499.16,
    rx: 32,
    fill: "#4649E5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_185_337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1072.2 6.96411V128.901C1072.2 147.163 1087 161.968 1105.26 161.968H1278.86",
    stroke: "white",
    strokeWidth: 4.27141,
    strokeLinecap: "round",
    strokeDasharray: "8.27 14.47"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1071.45,
    y: -43.9316,
    width: 62.13,
    height: 62.13,
    transform: "rotate(45 1071.45 -43.9316)",
    fill: "#2BCA76",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_185_337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.43006 41.0415H115.143C151.829 41.0415 181.57 70.7804 181.57 107.465C181.57 144.15 151.829 173.889 115.143 173.889H4.42987",
    stroke: "white",
    strokeWidth: 3.66106,
    strokeLinecap: "round",
    strokeDasharray: "7.09 12.4"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 18.53,
    y: 142.53,
    width: 62.13,
    height: 62.13,
    rx: 31.065,
    fill: "#FFD231",
    stroke: "black",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1276.8,
    height: 499.16,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_185_337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210.8,
    height: 169.47,
    fill: "white",
    transform: "translate(1070.13)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_185_337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 186,
    height: 136.39,
    fill: "white",
    transform: "translate(0 39.27)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTryBg);
export default __webpack_public_path__ + "static/media/tryBg.2e49361986db19deadb333dc946b68bf.svg";
export { ForwardRef as ReactComponent };